<template>
    <div class="page__wrapper" :class="'page-'+kapitel + ' ' + 'page-'+kapitel+'-'+pageid">
        <component :is="component" v-if="component" :key="componentKey" :kapitel="kapitel"/>
    </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: "PageWrapper",
    props:{
        pageid: "",
      kapitel: ""
    },
    data() {
      return {
        component: null,
        componentKey: 0,
      }
    },
    methods:{
      forceRerender() {
        this.componentKey += 1;
      }
    },
    computed: {
      loader() {
        if (!this.kapitel && !this.pageid) {
          return null
        }
        //console.log(this.$router)
        this.componentKey = this.kapitel.toString() + "-" + this.pageid.toString();
        //console.log("Component to render: ", `@/views/pages/${this.kapitel}/page-${this.pageid}`);
        return () => import(`@/views/pages/${this.kapitel}/page-${this.pageid}`)
      },
    },
    mounted() {
      this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/views/pages/00/page-010')
        })
    },
    watch:{
      $route (to, from){
        this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/views/pages/00/page-010')
          })
      }
    }
  }
</script>

<style scoped>

</style>